import * as React from 'react';
import useHttpClient from './useHttpClient';
import { useDebouncedCallback } from 'use-debounce';
import { AuStateType } from '../utils/constants';

export interface AddressDataType {
  fullAddress: boolean;
  moniker: string;
  partialAddress: string;
  picklist: string;
  postcode: string;
  score: number;
  state: AuStateType;
}

interface SearchType {
  searchTerm: string;
  searchTermLimit?: number;
}

export const useSearchAddress = () => {
  const [addressList, setAddressList] = React.useState<Partial<AddressDataType>[]>([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [{ error, loading: searching }, getAddress] = useHttpClient(
    {
      url: '/x-digital-remediation-qbe-anzo/api/v1/addresses',
    },
    { manual: true }
  );

  const debounced = useDebouncedCallback(async (value: string, limit: number) => {
    setSearchValue(value);
    try {
      if (value.length >= limit) {
        const { data } = await getAddress({
          method: 'GET',
          params: { searchTerm: value },
          headers: {
            'X-Mockable': 'False',
            'X-SourceSystem': 'CMS-SPA',
            'X-TrackingId': 'ec63e395-3844-4fc3-bf86-c6c39fc1d521',
            'X-Api-Context': 'CMS',
            'Content-Type': 'application/JSON',
          },
        });

        setAddressList(data.addressList);
      }
    } catch (error) {
      /* empty */
    }
  }, 500);

  const searchAddress = ({ searchTerm, searchTermLimit = 4 }: SearchType) => debounced(searchTerm, searchTermLimit);

  const clearAddressList = () => setAddressList([]);

  return { searchAddress, addressList, error, clearAddressList, searchValue, searching };
};
